import React from 'react';
import { images } from '../data/site';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section id="book" className="relative flex min-h-[80svh] w-full items-center justify-center overflow-hidden bg-ocean-deep" data-id="element-86" data-mp="vg7s840t2akd">
      <img src={images.cta} alt="Aerial view of the Taveuni coastline at sunset" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-87" data-mp="19cmaqagzlncz" />
      <div className="absolute inset-0 bg-ocean-deep/65" data-id="element-88" data-mp="1jb212b86wslf" />

      <Reveal className="relative mx-auto max-w-3xl px-5 py-28 text-center sm:px-8 lg:py-36" data-id="element-89" data-mp="1ed0ma2hsrffr">
        <h2 className="font-serif text-[clamp(2.25rem,6vw,5rem)] font-light leading-[1.05] text-ivory" data-id="element-90" data-mp="1t1wp9l4zy29i">
          Ready to experience
          <span className="block italic text-gold-soft" data-id="element-91" data-mp="1o4n1e9x99yns">Taveuni?</span>
        </h2>
        <p className="mx-auto mt-7 max-w-lg text-[17px] leading-relaxed text-ivory/80" data-id="element-92" data-mp="2245z08sfxrlu">
          Stay local. Explore the island. Wake up in paradise.
        </p>
        <a href="#book" className="mt-11 inline-block rounded-full bg-ivory px-11 py-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-forest-deep transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:bg-gold hover:shadow-lift" data-id="element-93" data-mp="n649xjw7zkjt">
          Book your stay
        </a>
        <p className="mt-5 text-[12px] uppercase tracking-[0.16em] text-ivory/55" data-id="element-94" data-mp="123wni6i7hyvd">
          Check availability and rates.
        </p>
      </Reveal>
    </section>;
}